export var createName = function createName(name) {
  return "@@signal/".concat(name);
};
export var createSymbol = function createSymbol(id) {
  return Symbol(createName(id));
};
export default createSymbol;